import cn from 'clsx'

import { ImageBox, NavLink } from 'shared-components'

import BlockArrow from '../../images/blockArrow'

import s from './ProjectTile.module.sass'

function ProjectTile({ project, linkTarget }: any) {
    const { title, slug, featuredImage, secondaryImage, projectCategories, year, showNa } = project

    const _projectCategories = projectCategories
        ? projectCategories.map((category: any) => category?.name).join(', ')
        : null

    return (
        <div className={s.ProjectTile}>
            <div>
                <NavLink href={`/our-work/${slug}`} target={linkTarget || ''} className={s.Link}>
                    <div className={s.Main}>
                        <div className={s.Image}>
                            {BlockArrow}
                            <div className={s.SecondaryImage}>
                                {secondaryImage && <ImageBox image={secondaryImage} width={500} height={500} />}
                            </div>
                            {featuredImage && <ImageBox image={featuredImage} width={500} height={500} />}
                        </div>
                        <div className={s.Content}>
                            {_projectCategories && (
                                <div
                                    className={cn(s.ProjectCategory, 'smallCaps')}
                                    dangerouslySetInnerHTML={{
                                        __html: _projectCategories,
                                    }}
                                />
                            )}
                            <div className={s.Title}>{title && <h5 dangerouslySetInnerHTML={{ __html: title }} />}</div>
                        </div>
                    </div>
                    {year && year > 0 && (
                        <div
                            className={cn(s.Year, 'smallCaps')}
                            dangerouslySetInnerHTML={{
                                __html: year,
                            }}
                        />
                    )}
                    {showNa && !year ? (
                        <div className={cn(s.Year, 'smallCaps')} data-title="Year">
                            N/A
                        </div>
                    ) : null}
                </NavLink>
            </div>
        </div>
    )
}

export default ProjectTile
